import { render } from "./PdfViewer.vue?vue&type=template&id=1c2fd3da&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=1c2fd3da&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2fd3da"]])

export default __exports__